
import React, { Component } from 'react';
import './AccountInfo.css';

import cloud from '../../../../assets/icons/cloud.svg';
import tik from '../../../../assets/icons/tik.svg';
import responsive from '../../../../assets/icons/responsive.svg';


export default class AccountInfo extends Component {
  render() {
    return (
      <div className="account-info d-flex flex-column">
        <div className="account-info__top" onClick={() => this.props.closeConfirm()}>

        </div>
        <div className="account-info__scale">
          <div className="account-info__bottom d-flex flex-column">
            <h1 className="mb-3">ساختن اکانت به شما این امکان رو می‌دهد تا</h1>
            <div className="account-info__bottom--item d-flex">
              <div className="d-flex">
                <img src={tik} className="account-info__tik" />
                <div>قویم خود را  بین همه دستگاه های مورد نظر خود همگام سازی کنید</div>
              </div>
              <img src={responsive} className="account-info__cloud" />
            </div>
            <div className="account-info__bottom--item d-flex">
              <div className="d-flex">
                <img src={tik} className="account-info__tik" />
                <div>قویم خود را  بین همه دستگاه های مورد نظر خود همگام سازی کنید</div>
              </div>
              <img src={cloud} className="account-info__cloud" />
            </div>
            <div className="account-info__bottom--submit d-flex mt-4">
              <button className="btn" onClick={() => this.props.closeConfirm()}>باشه ممنون که بهم اطلاع دادی</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

